// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZJGa","title":"styles_title__1RKxf"};